import { useEffect, useState } from 'react';
import { APP_STORE_URL } from './storeLinks';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative pt-20 pb-12 sm:pt-32 sm:pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#f8f7f6] to-white"></div>
      
      {/* Orange Wave */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
        <svg viewBox="0 0 500 500" className="w-full h-full">
          <path
            d="M0,100 Q250,200 500,100 L500,0 L0,0 Z"
            fill="#e77e23"
          />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#111827] leading-tight mb-6">
              Al, Sat, Paylaş,<br />Yardımlaş
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed">
              Mahallebi ile yakınındaki güvenilir komşularınla buluş. Ürün sat, hizmet sun, ihtiyacını paylaş veya etkinlik duyurusu yap.
            </p>

            {/* App Store Buttons */}
            <div className="flex flex-wrap gap-4 mb-6">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-all cursor-pointer"
              >
                <i className="ri-apple-fill text-2xl mr-3"></i>
                <div className="text-left">
                  <div className="text-xs">Download on the</div>
                  <div className="text-sm font-semibold whitespace-nowrap">App Store</div>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.mahallebi.tr&hl=tr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition-all cursor-pointer"
              >
                <i className="ri-google-play-fill text-2xl mr-3"></i>
                <div className="text-left">
                  <div className="text-xs">GET IT ON</div>
                  <div className="text-sm font-semibold whitespace-nowrap">Google Play</div>
                </div>
              </a>
            </div>

            {/* Web Login Link */}
            <a
              href="/app/"
              className="inline-flex items-center text-[#e77e23] font-semibold hover:text-[#d56d12] transition-colors cursor-pointer"
            >
              Web'den Giriş Yap
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          {/* Right Content - Phone Mockups */}
          <div
            className={`relative transition-all duration-1000 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            {/* overflow-hidden mobil'de taşmayı kesin önler, rotated mockup'lar ekrana sığar */}
            <div className="hero-phone-mockups relative flex items-center justify-center gap-2 sm:gap-6 overflow-hidden px-4">
              {/* iPhone Mockup - Ana Sayfa Feed */}
              <div className="relative transform -rotate-6 hover:rotate-0 transition-transform duration-500 shrink-0">
                <div className="w-32 h-[260px] sm:w-56 sm:h-[450px] lg:w-64 lg:h-[520px] bg-black rounded-[1.5rem] sm:rounded-[3rem] p-1.5 sm:p-3 shadow-2xl">
                  <div className="w-full h-full bg-white rounded-[1.25rem] sm:rounded-[2.5rem] overflow-hidden">
                    <img
                      src="/images/hero-feed.webp"
                      alt="Ana Sayfa Feed"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>

              {/* Android Mockup - İlan Detay */}
              <div className="relative transform rotate-6 hover:rotate-0 transition-transform duration-500 shrink-0">
                <div className="w-32 h-[260px] sm:w-56 sm:h-[450px] lg:w-64 lg:h-[520px] bg-gray-800 rounded-[1.5rem] sm:rounded-[3rem] p-1.5 sm:p-3 shadow-2xl">
                  <div className="w-full h-full bg-white rounded-[1.25rem] sm:rounded-[2.5rem] overflow-hidden">
                    <img
                      src="/images/hero-ilan-detay.webp"
                      alt="İlan Detay"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Animation */}
            <style>{`
              @keyframes hero-phone-float {
                0%, 100% { transform: translateY(0px); }
                50% { transform: translateY(-20px); }
              }
              .hero-phone-mockups > div > div {
                animation: hero-phone-float 3s ease-in-out infinite;
              }
              .hero-phone-mockups > div:last-child > div {
                animation-delay: 0.5s;
              }
              @media (prefers-reduced-motion: reduce) {
                .hero-phone-mockups > div > div { animation: none; }
              }
            `}</style>
          </div>
        </div>
      </div>
    </section>
  );
}
